import { Hero } from "@/components/landing/Hero";
import { Psychological } from "@/components/landing/Psychological";
import { Example } from "@/components/landing/Example";
import { HeroPhoneMobile } from "@/components/landing/HeroPhoneMobile";
import { CoreMessage } from "@/components/landing/CoreMessage";
import { WhyLeadzi } from "@/components/landing/WhyLeadzi";
import { Categories } from "@/components/landing/Categories";
import { AppShowcase } from "@/components/landing/AppShowcase";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";

export default function Home() {
  return (
    <>
      <Hero />
      <Psychological />
      <Example />
      <HeroPhoneMobile />
      <CoreMessage />
      <WhyLeadzi />
      <Categories />
      <AppShowcase />
      <FAQ />
      <FinalCTA />
    </>
  );
}
